// import {foundationActionsMenuStyles} from '@genesislcap/foundation-ui';
import { actionsMenuBaseStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
export const zeroActionsMenuStyles = (context, definition) => css `
  :host {
    --actions-opener-heigght-multiplier: 0.6px;
    --menu-item-height-multiplier: 0.5px;
  }

  .actions-menu {
    padding: calc(var(--design-unit) * 1px) 0;
  }

  zero-menu-item {
    display: flex;
    user-select: none;
    margin: 0 calc(var(--design-unit) * 1px);
  }

  zero-menu-item::part(content) {
    margin-inline: 10px;
  }

  zero-menu-item[disabled] {
    pointer-events: none;
  }

  ${actionsMenuBaseStyles(context, definition)}
`;
